/**
 * @link ./src/assets/svg/sprite/SolidShoePrints.svg
 **/
export const SolidShoePrints_viewBox_x = 0
export const SolidShoePrints_viewBox_y = 0
export const SolidShoePrints_viewBox_w = 40
export const SolidShoePrints_viewBox_h = 32
export const SolidShoePrints_viewBox_d = new Path2D(
  'M 26,0 C 22.01875,0 16,2 16,2 V 10 C 19,10 20.75,11 22.5,12 24.25,13 26,14 29,14 32.525,14 40,13 40,8 40,3 32,0 26,0 Z M 8,6 C 8,8.20625 9.79375,10 12,10 H 14 V 2 H 12 C 9.79375,2 8,3.79375 8,6 Z M 18,32 C 24,32 32,29 32,24 32,19 24.525,18 21,18 18,18 16.25,19 14.5,20 12.75,21 11,22 8,22 V 30 C 8,30 14.01875,32 18,32 Z M 0,26 C 0,28.20625 1.79375,30 4,30 H 6 V 22 H 4 C 1.79375,22 0,23.79375 0,26 Z'
)
export const SolidShoePrints_type = 'svg'

export const SolidFlag_viewBox_x = 0
export const SolidFlag_viewBox_y = 0
export const SolidFlag_viewBox_w = 448
export const SolidFlag_viewBox_h = 512
export const SolidFlag_viewBox_d = new Path2D(
  'M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 64 0 368 0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-247.7c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48l0-16z'
)

export const ClassicRightToBracket_viewBox_x = 0
export const ClassicRightToBracket_viewBox_y = 0
export const ClassicRightToBracket_viewBox_w = 512
export const ClassicRightToBracket_viewBox_h = 512
export const ClassicRightToBracket_viewBox_d = new Path2D(
  'M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z'
)

export const ClassicRightFromBracket_viewBox_x = 0
export const ClassicRightFromBracket_viewBox_y = 0
export const ClassicRightFromBracket_viewBox_w = 512
export const ClassicRightFromBracket_viewBox_h = 512
export const ClassicRightFromBracket_viewBox_d = new Path2D(
  'M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z'
)

// now using wooden crate
export const TransportLoadedL_d = new Path2D(
  'M 2 1 L 8 1 L 8 11 L 14 11 L 14 17 L 2 17 L 2 1'
)

export const ClassicPlus_viewBox_x = 0
export const ClassicPlus_viewBox_y = 0
export const ClassicPlus_viewBox_w = 448
export const ClassicPlus_viewBox_h = 512
export const ClassicPlus_viewBox_d = new Path2D(
  'M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z'
)

export const MagnifyingGlass_x = 0
export const MagnifyingGlass_y = 0
export const MagnifyingGlass_w = 512
export const MagnifyingGlass_h = 512
export const MagnifyingGlass_d = new Path2D(
  'M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z'
)

export const SolidPaintBrush_x = 0
export const SolidPaintBrush_y = 0
export const SolidPaintBrush_w = 576
export const SolidPaintBrush_h = 512
export const SolidPaintBrush_d = new Path2D(
  'M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z'
)

export const SolidEraser_x = 0
export const SolidEraser_y = 0
export const SolidEraser_w = 576
export const SolidEraser_h = 512
export const SolidEraser_d = new Path2D(
  'M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7L288 480l9.4 0L512 480c17.7 0 32-14.3 32-32s-14.3-32-32-32l-124.1 0L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416l-9.4 0-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z'
)

export const SolidArrowsTurnToDots_x = 0
export const SolidArrowsTurnToDots_y = 0
export const SolidArrowsTurnToDots_w = 512
export const SolidArrowsTurnToDots_h = 512
export const SolidArrowsTurnToDots_d = new Path2D(
  'M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-53 43-96 96-96l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM384 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z'
)

export const SolidArrowsSplitUpAndLeft_x = 0
export const SolidArrowsSplitUpAndLeft_y = 0
export const SolidArrowsSplitUpAndLeft_w = 512
export const SolidArrowsSplitUpAndLeft_h = 512
export const SolidArrowsSplitUpAndLeft_d = new Path2D(
  'M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3 352 384c0 35.3 28.7 64 64 64l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-70.7 0-128-57.3-128-128c0-35.3-28.7-64-64-64l-114.7 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256 224 256c23.3 0 45.2 6.2 64 17.1l0-163.9-41.4 41.4z'
)

export const SolidCrossHairs_x = 0
export const SolidCrossHairs_y = 0
export const SolidCrossHairs_w = 512
export const SolidCrossHairs_h = 512
export const SolidCrossHairs_d = new Path2D(
  'M256 0c17.7 0 32 14.3 32 32l0 10.4c93.7 13.9 167.7 88 181.6 181.6l10.4 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-10.4 0c-13.9 93.7-88 167.7-181.6 181.6l0 10.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-10.4C130.3 455.7 56.3 381.7 42.4 288L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l10.4 0C56.3 130.3 130.3 56.3 224 42.4L224 32c0-17.7 14.3-32 32-32zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6l0-20.6c0-17.7 14.3-32 32-32s32 14.3 32 32l0 20.6c58.3-12.5 104.1-58.4 116.6-116.6L384 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l20.6 0C392.1 165.7 346.3 119.9 288 107.4l0 20.6c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-20.6C165.7 119.9 119.9 165.7 107.4 224l20.6 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-20.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
)

// viewBox="0 0 384 512

export const SolidArrowDownLong_x = 0
export const SolidArrowDownLong_y = 0
export const SolidArrowDownLong_w = 384
export const SolidArrowDownLong_h = 512

export const SolidArrowDownLong_d = new Path2D(
  'M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7 224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 370.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z'
)

export const AiOutlineVerticalAlignMiddle_x = 0
export const AiOutlineVerticalAlignMiddle_y = 0
export const AiOutlineVerticalAlignMiddle_w = 1024
export const AiOutlineVerticalAlignMiddle_h = 1024
export const AiOutlineVerticalAlignMiddle_d = new Path2D(
  'M859.9 474H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zm-353.6-74.7c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H550V104c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v156h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.6zm11.4 225.4a7.14 7.14 0 0 0-11.3 0L405.6 752.3a7.23 7.23 0 0 0 5.7 11.7H474v156c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V764h62.8c6 0 9.4-7 5.7-11.7L517.7 624.7z'
)

export const GameIcons_Delapouite_WoodenCrate_x = 0
export const GameIcons_Delapouite_WoodenCrate_y = 0
export const GameIcons_Delapouite_WoodenCrate_w = 512
export const GameIcons_Delapouite_WoodenCrate_h = 512
export const GameIcons_Delapouite_WoodenCrate_d = new Path2D(
  'M37.727 25l78 78h280.546l78-78H37.727zM25 37.727v436.546l78-78V115.727l-78-78zm462 0l-78 78v280.546l78 78V37.727zM79.957 40a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zM432 40.793a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zM112 72a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zm287.45 0a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zm63.42 0a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zM48 73.047a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zM79.395 104a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zm352.605.2a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zM121 121v193.273l53.7-53.7L174.065 121H121zm71.064 0l.555 121.654 54.38-54.38V121h-54.936zM265 121v49.273L314.273 121H265zm74.727 0L121 339.727V391h51.273L391 172.273V121h-51.273zM391 197.727l-53.023 53.023V391H391V197.727zm-71.023 71.023L265 323.727V391h54.977V268.75zM247 341.727L197.727 391H247v-49.273zM77.97 392a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zm354.03.658a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zM115.727 409l-78 78h436.546l-78-78H115.727zM48 423.752a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zm64 .8a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zm288 .712a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zm64 4.74a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zM432 456a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zm-352 2.56a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8z'
)

export const GameIcons_Delapouite_Square_x = 0
export const GameIcons_Delapouite_Square_y = 0
export const GameIcons_Delapouite_Square_w = 512
export const GameIcons_Delapouite_Square_h = 512
export const GameIcons_Delapouite_Square_d = new Path2D(
  'M23.05 23.05V488.9H488.9V23.05zm17.9 17.9H471.1V471.1H40.95z'
)
